import { red } from '@material-ui/core/colors';
import { palette } from './palette';
import { colors } from '@material-ui/core';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
      '& .section-header__title': {
        fontFamily: 'Rubik !important',
        fontWeight: 600,
        fontSize: '32px !important',
      },
      '& .section-header__subtitle': {
        fontFamily: 'Rubik !important',
        fontWeight: 400,
        fontSize: '18px !important',
        color: palette.text.subtitle,
      },
    },
  },

  '.header-wrapper': {
    background: `${palette.text.highlight} !important`,
    padding: '8px 16px',
    '& .MuiToolbar-root': {
      minHeight: '72px',
    },
  },
  '.footer-wrapper': {
    backgroundColor: 'palette.background.footer !important',
    color: 'palette.text.secondary !important',
    '& a': {
      color: 'palette.text.secondary !important'
    }
  },

  '.castlehillsdental-container': {
    /* General Styles */
    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
      backgroundColor: palette.primary.light,
    },
    '& .MuiSwitch-track': {
      border: `1px solid ${palette.primary.main}`,
    },
    '& .MuiSwitch-thumb': {
      background: palette.primary.main,
    },

    '& .normal-text': {
      fontWeight: 300,
    },
    '& .hero-home-button': {
      backgroundColor: `${palette.text.highlight} !important`,
      color: palette.text.primary,
      borderColor: palette.text.highlight,
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section,.faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      backgroundColor: palette.background.header,
      color: palette.text.highlight,

      '& h1,& h2,& h3,& h4,& p': {
        color: palette.text.highlight,
      },
    },

    '& .subscription-wrapper, .addonsWrapper, .plan-selection-container': {
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.primary.light,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* App main - styles */
    '& .app-main-content': {
      paddingTop: 0,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      '& .hero-background': {
        objectFit: 'cover',
        backgroundColor: palette.background.fill,
        objectPosition: 'right center',
        '@media screen and (max-width: 900px)': {
          height: '340px',
          marginLeft: '10',
        },
        '@media screen and (min-width: 1800px)': {
          objectFit: 'contain',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '700px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },
      '& .home-hero-title': {
        fontSize: '4.0rem',
        fontFamily: 'Rubik !important',
        fontWeight: 500,
        maxWidth: 634,
        letterSpacing: '-1.48px',
        color: palette.text.primary,
        fontSize: '64px !important',
      },
      '& .MuiButton-containedSecondary': {
        color: 'white !important',
      },
      '& .home-hero-subtitle': {
        maxWidth: 550,
      },
      '@media screen and (max-width: 900px)': {
        '& .home-hero-title': {
          fontSize: '2.5rem !important',
        },
        '& .home-hero-subtitle': {
          fontSize: 16,
          fontFamily: 'Inter Display',
          maxWidth: 550,
        },
      },
    },

    /* Benefits - Styles */
    '& .definition-Wrapper': {
      paddingBottom: '0px !important',
      '@media (max-width: 600px)': {
        paddingBottom: '0px !important',
      },
      '@media(max-width: 900px)': {
        paddingInline: '30px !important',
      },
      '& .section-header__title': {
        fontFamily: 'Gasket !important',
        letterSpacing: '1.5px !important',
      },
      '& .section-alternate__content': {
        padding: '48px 16px',

        '@media (min-width: 600px)': {
          padding: '48px',
        },
        '@media (min-width: 900px)': {
          padding: '72px 48px 80px',
        },
      },
      '& .definition-services-grid': {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 24,
        justifyContent: 'center',
        alignItems: 'stretch',

        '@media screen and (max-width: 900px)': {
          gridTemplateColumns: '1fr',
        },
        '& .definition-service-tile': {
          '@media (min-width: 600px)': {
            padding: '10px 24px',
          },
        },

      },
      '& .definition-services-grid': {
        paddingTop: '16px !important',
      },
      '& .MuiCardContent-root': {
        padding: 32,
        '@media (max-width: 600px)': {
          padding: '10px 24px',
        },
      },
      '& .section-header__title': {
        color: palette.text.title,
        fontFamily: 'Gasket !important',
        letterSpacing: '1.5px !important',
        fontWeight: 400,
        fontSize: '60px !important',
      },
      '& .definition-service-header': {
        justifyContent: 'flex-end',
        flexDirection: 'row-reverse',
        marginBottom: 24,
      },
      '& .definition-service-title': {
        marginLeft: 16,
        fontWeight: 400,
        letterSpacing: '-0.32px',
        fontFamily: 'Rubik !important',
        color: palette.text.primary,
      },
      '& .definition-service-description': {
        marginBottom: 0,
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.surface.pricing,
      },
      '& .section-header__title, .section-header__subtitle, .summary-text, .summary-subtext, .subscription-tabs-label':
      {
        color: `${palette.text.highlight} !important`,
        fontFamily: 'Gasket !important',
        letterSpacing: '1.5px !important',
      },
      '& .section-header__subtitle': {
        fontFamily: 'Rubik !important',
      },
      '& .subscription-tabs-label': {
        fontFamily: 'Rubik !important',
      },
      '& .summary-text , .summary-subtext': {
        fontSize: '20px !important',
        fontWeight: 400,
        fontFamily: 'Rubik !important',
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          border: 'none',
          color: palette.text.alternate,
          '&:hover': {
            border: `1px solid ${palette.primary.main}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .MuiButton-containedSecondary': {
            backgroundColor: palette.text.highlight,
            color: palette.text.alternate,
            border: `1px solid ${palette.primary.main} !important`,
            '&:hover': {
              opacity: 1,
            },
          },
        },
        '& .subscription-section': {
          objectFit: 'cover',
          '& .section-header': {
            maxWidth: 620,
            margin: '0px auto 32px',
          },
          '& .plans-loader': {
            color: palette.text.highlight,
          },
        },
        '& .savings-summary-link': {
          color: palette.text.highlight,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
        '& .description-cta__title': {
          fontFamily: 'Rubik !important',
          color: 'red !important',
        },
      },
    },

    /* Benefits Section - Styles */
    '& .benefits-section': {
      '& .section': {
        '@media (max-width: 899.95px)': {
          padding: '20px 20px !important',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.text.highlight,

      '& .section': {
        padding: '20px !important',
        '@media (min-width: 600px)': {
          padding: '40px 64px !important',
        },
      },

      '& .howitworks-title': {
        marginBottom: 40,
      },
      '& .section-header__title': {
        color: palette.text.title,
        fontFamily: 'Gasket !important',
        fontWeight: 400,
        fontSize: '60px !important',
        letterSpacing: '1.5px !important',
      },
      '& .section-header__subtitle': {
        fontFamily: 'Rubik !important',
        color: palette.text.howitworkssubtitle,
      },

      '& .howitworks-wrapper': {
        padding: 20,
      },

      '& .howitworks-wrapper-left': {
        padding: 20,
      },

      '& .makeStyles-root-54': {
        padding: 0,
      },

      '& .how-cover-image': {
        backgroundSize: 'cover',
      },

      '& .step-counter': {
        borderRadius: '50%',
        backgroundColor: palette.surface.pricing,
        color: palette.secondary.contrastText,
      },
      '& .step-title': {
        color: palette.text.primary,
      },
      '& .step-content': {
        fontFamily: 'Rubik !important',
        color: 'palette.text.secondary !important',
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '& .working-steps-container:not(:last-child)': {
        paddingBottom: 30,
      },

      '@media screen and (max-width: 900px)': {
        '& .howitworks-wrapper-left': {
          padding: '5px',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '100px',
        },
      },

      '@media (max-width: 600px)': {
        paddingTop: '0px !important',

      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savingsDataContainer': {
        '& .footer-bar': {
          backgroundColor: palette.surface.savings,
        },
        '& .view-more-button': {
          backgroundColor: palette.primary.main,
          color: palette.text.highlight,
        }
      },
      '& .section-header': {
        '& .section-header__title': {
          color: palette.text.primary,
        },
        '& .section-header__subtitle': {
          color: palette.text.primary,
        },
      },
      '& .select-location-grid': {
        width: '100%',
        maxWidth: 'unset',
        flexBasis: 'auto',
      },
      '& .service-procedure-table': {
        border: `1px solid ${palette.secondary.main} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
          backgroundColor: palette.text.primary,
        },

        '& .savings-header': {
          color: palette.text.primary,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .savings-contact-card': {
        padding: '0px 60px !important',
        backgroundColor: palette.background.footer
      },

      '& .footer-bar-text': {
        color: palette.text.primary,
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.background.footer,
      },
      '& .section-header__title': {
        color: palette.text.primary,
        fontFamily: 'Rubik !important',
        fontWeight: 600,
        fontSize: '32px !important',
      },
      '& .section-header__subtitle': {
        color: `palette.text.secondary !important`,
        fontFamily: 'Rubik !important',
        fontWeight: 400,
        fontSize: '20px !important',
      },
      '& .MuiButton-containedPrimary': {
        backgroundColor: palette.primary.main,
        borderColor: palette.surface.learnMore,
        color: palette.text.highlight,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.primary.light,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        maxWidth: 'unset',
      },
      '& .header-container': {
        margin: '0',
      },
      '@media screen and (max-width: 900px)': {
        '& .faq-hero-internal': {
          marginTop: '10px',
          padding: '64px 24px !important',
        },
      },
    },
    '& .faqInnerContainer': {
      '& .Mui-selected': {
        backgroundColor: palette.surface.grey,
        color: palette.text.primary,
      },
    },
    '& .MuiTypography-subtitle1': {
      color: palette.text.subtitle,
    },
    '& .accordion__collapsable-text': {
      color: palette.text.secondary,
    },
    '& .faq-contact-section': {
      backgroundColor: palette.background.footer,
      width: '100%',
      margin: 'unset',
      maxWidth: 'unset',
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'none',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: 'palette.background.footer',
      color: palette.text.secondary,
      '& .contact-card-title': {
        color: 'black !important',
      },
      '& .contact-card-subtitle': {
        color: palette.text.secondary,
      },
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
      backgroundColor: palette.primary.main,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      // maxWidth: '898px',
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.header,
        color: palette.background.header,
      },
    },

    // Stepper Icon Styles - Completed vs Uncompleted
    '& .MuiStepIcon-root': {
      color: 'transparent', // Default: transparent background
      width: 32,
      height: 32,
      borderColor: palette.background.header, // Common border color for all states

      // Completed step - filled circle with checkmark
      '&.MuiStepIcon-completed': {
        color: palette.background.header, // Filled background
        '& .MuiSvgIcon-root': {
          color: palette.background.header,
        },
      },

      // Active step - filled circle with number
      '&.MuiStepIcon-active': {
        color: palette.background.header, // Filled background
        '& .MuiSvgIcon-root': {
          color: palette.background.header,
        },
        '& .MuiStepIcon-text': {
          fill: palette.text.highlight, // White text on filled background
        },
      },

      // Uncompleted step - empty circle with number
      '&:not(.MuiStepIcon-completed):not(.MuiStepIcon-active)': {
        color: 'transparent', // Transparent background
        '& .MuiSvgIcon-root': {
          color: 'transparent',
        },
        '& .MuiStepIcon-text': {
          fill: palette.background.header, // Dark text on transparent background
        },
      },
    },

    // Stepper Label Styles
    '& .MuiStepLabel-label': {
      color: palette.text.primary,

      '&.MuiStepLabel-completed': {
        color: palette.text.primary,
        fontWeight: 500,
      },

      '&.MuiStepLabel-active': {
        color: palette.text.primary,
        fontWeight: 500,
      },
    },

    // Stepper Connector Line
    '& .MuiStepConnector-lineHorizontal': {
      borderColor: palette.background.header,
      borderTopWidth: 2,
    },

    // Stepper Container Style
    '& .stepperContainer': {
      '@media(max-width: 900px)': {
        display: 'none',
      }
    },

    '& .stepperItems': {
      marginTop: 24,
    },
  },
};
